// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"47":"2e53efff","96":"e09fef04"}[chunkId] + ".chunk.js";
};